import React, { createContext, useContext, useState } from 'react'

type LayoutContextType = {
  headerHeight?: number
  sidebarWidth?: number
  setLayout: (values: Partial<Pick<LayoutContextType, 'headerHeight' | 'sidebarWidth'>>) => void
}

const LayoutContext = createContext<LayoutContextType>({
  headerHeight: 0,
  sidebarWidth: 0,
  setLayout: () => {
    return null
  },
})

export const useLayoutContext = () => useContext(LayoutContext)

export const LayoutProvider: React.FC<{
  headerHeight?: number
  sidebarWidth?: number
  children: React.ReactNode
}> = ({ headerHeight, sidebarWidth, children }) => {
  const [layout, setLayoutState] = useState({
    headerHeight,
    sidebarWidth,
  })

  const setLayout = (values: Partial<Pick<LayoutContextType, 'headerHeight' | 'sidebarWidth'>>) => {
    setLayoutState((prev) => ({ ...prev, ...values }))
  }

  return (
    <LayoutContext.Provider value={{ ...layout, setLayout }}>{children}</LayoutContext.Provider>
  )
}
